import { ibkApi } from '@ibk/shared-config';
import { RECHARGE_REPORT_TYPE_BENEFICIARIES, RECHARGE_REPORT_TYPE_ORDERS } from '../utils/rechargeReportUtils';
import { blobToBase64, parseOrderPaymentPdfResponse } from './contractOrderPaymentApi';
export { RECHARGE_REPORT_TYPE_BENEFICIARIES, RECHARGE_REPORT_TYPE_ORDERS };
const buildParamsBody = (params) => {
    const { startDate, endDate } = params;
    if (params.type === RECHARGE_REPORT_TYPE_ORDERS) {
        return {
            startDate,
            endDate,
            ...(params.productId?.length ? { productId: params.productId } : {}),
            ...(params.screenStatus?.length ? { screenStatus: params.screenStatus } : {}),
        };
    }
    return { startDate, endDate, beneficiaryIds: params.beneficiaryIds };
};
export const buildGenerateRechargeReportPdfMutation = (params) => ({
    url: `/v1/benefits/contracts/${params.contractId}/orders/report/pdf`,
    method: 'POST',
    body: {
        type: params.type,
        params: buildParamsBody(params),
    },
    responseHandler: parseOrderPaymentPdfResponse,
});
export const contractRechargeReportApi = ibkApi.injectEndpoints({
    endpoints: build => ({
        generateRechargeReportPdf: build.mutation({
            query: buildGenerateRechargeReportPdfMutation,
            transformResponse: (response) => blobToBase64(response),
        }),
    }),
    overrideExisting: false,
});
export const { useGenerateRechargeReportPdfMutation } = contractRechargeReportApi;
